<template>
    <div id="preorder">
        <van-icon
                @click="goBack"
                class="back-icon"
                size="0.5rem"
                color="#fff"
                name="arrow-left"
        />
        <van-cell-group class="address-list">
            <van-cell
                    :to="'/order/addresslist/1/' + this.$route.params.id"
                    class="address-item"
                    v-show="sendList.length <= 0">
                <span class="address-icon ji-icon" slot="icon"></span>
                <div class="item-info">
                    请点击输入寄件人相关信息
                </div>
                <span class="address-book" slot="right-icon"></span>
            </van-cell>
            <address-item
                    :type="'1'"
                    :order-number="orderNumber"
                    v-for="(item, index) in sendList"
                    :key="index"
                    :address-info="item"
                    :index="index"/>
            <van-cell
                    to="/addresslist/2"
                    class="address-item"
                    v-show="acceptList.length <= 0">
                <span class="address-icon shou-icon" slot="icon"></span>
                <div class="item-info">
                    请点击输入收货人相关信息
                </div>
                <span class="address-book" slot="right-icon"></span>
            </van-cell>
            <accept-address
                    v-for="(item, index) in acceptList"
                    :key="item.id"
                    :address-info="item"
                    :showDel="acceptList.length !== 1"
                    @on-pay-means-click="handlePayMeansClick(index)"
                    @on-delivery-click="handleDeliveryClick(index)"
                    @on-pack-click="handlePackClick(index)"
                    @on-product-click="handleProductClick(index)"
            ></accept-address>
        </van-cell-group>


        <div class="btn">
            <van-button @click="submit" size="large" type="danger">提交</van-button>
        </div>

        <!-- 物流公司选择框 -->
        <van-popup class="company-popup" position="bottom" v-model="show.company">
            <h2 class="popup-title">
                <span>物流选择</span>
                <van-icon @click="closeCompany" name="close" size="0.5rem"></van-icon>
            </h2>
            <van-cell-group class="company-list">
                <van-cell v-if="companyList.length <= 0">暂无物流公司！</van-cell>
                <van-cell
                        @click="selCompany(index)"
                        v-for="(item, index) in companyList"
                        :key="item.logisticsCompanyId"
                        class="company-item">
                    <span class="company-icon" slot="icon"></span>
                    <van-row>
                        <van-col span="24">{{ item.logisticsCompanyName }}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24">
                            价格：{{ item.price }}/kg
                            <span class="company-time">时效：{{ item.time }}</span>
                        </van-col>
                    </van-row>
                </van-cell>
            </van-cell-group>
        </van-popup>
        <!-- 付款方式选择框 -->
        <van-actionsheet
                @select="selPayMent"
                @cancel="cancelPayMent"
                v-model="show.pay"
                :actions="$store.state.dict.pay"
                cancel-text="重置"
        />
        <!-- 配送方式选择框 -->
        <van-actionsheet
                @select="selDelivery"
                @cancel="cancelDelivery"
                v-model="show.delivery"
                :actions="$store.state.dict.delivery"
                cancel-text="重置"
        />
    </div>
</template>

<script>
    import {Dialog, Toast} from "vant";
    import AddressItem from "../../components/SelAddressItem.vue";
    import Coupon from "../../components/Coupon.vue";

    export default {
        name: "ModifyOrder",
        components: {
            AcceptAddress: () => import('../address/components/CheckedAcceptAddress'),
            AddressItem,
            Coupon,
        },
        data() {
            return {
                orderNumber: this.$route.params.id,
                show: {
                    timePicker: false,
                    company: false,
                    worker: false,
                    transport: false,
                    pack: false,
                    pay: false,
                    delivery: false,
                    message: false,
                    coupon: false
                },
                columns: {},
                timeColumns: [],
                workerRadio: "",
                companyList: [],
                concatWorkerList: [],
                workerList: [],
                transportwayList: [],
                packList: [],
                payList: [],
                deliveryList: [],
                couponList: [],
                workerSearchKey: "",
                coupon: 0,
                params: {},
                serviceList: [//服务网点
                    {
                        address: "广东省广州市白云区白云湖街道南约大街6号",
                        distance: 1210,
                        locationCoordinates: "113.258399,23.222481",
                        organId: "034cf81975fb4e4ba730ce4c3dfd1da9",
                        organName: "夏茅总部",
                        phone: "18576951333",
                    },
                    {
                        address: "广州市白云区石井街庆丰纺织城庆丰纺织一路113号",
                        distance: 1210,
                        locationCoordinates: "113.250298,23.216365",
                        organId: "dbbb65798d044735bc2ceda7c7a3f4bd",
                        organName: "石井庆丰",
                        phone: "18620685465",
                    }
                ],
                data: {
                    goodsNumber: ''
                },
            };
        },
        created() {
            this.getOrder();
        },
        computed: {
            sendList() {
                return this.$store.getters.getCheck("1");
            },
            acceptList() {
                return this.$store.getters.getCheck("2");
            }
        },
        watch: {
            workerSearchKey(newVal) {
                this.workerList.forEach(val => {
                    if (
                        val.name.indexOf(newVal) !== -1 ||
                        val.phone.indexOf(newVal) !== -1
                    ) {
                        val.show = true;
                    } else {
                        val.show = false;
                    }
                });
                this.concatWorkerList.forEach(val => {
                    if (
                        val.name.indexOf(newVal) !== -1 ||
                        val.phone.indexOf(newVal) !== -1
                    ) {
                        val.show = true;
                    } else {
                        val.show = false;
                    }
                });
            }
        },
        methods: {
            // 获取订单详情
            getOrder() {
                let params = {
                    params: this.$route.params.id
                };
                this.$axios.post("merchant/getOrderInfo", params).then(res => {
                    if (res.data.code === 200) {
                        let data = res.data.data;
                        this.data = data
                        data.speedPartsName = data.speedParts;
                        data.speedParts = data.speedPartsId;
                        delete data.speedParts;
                        delete data.speedPartsId;
                        data.isNeedFiberBag = data.isNeedFiberBag.toString();
                        this.workerRadio = data.pullPackWorker;
                        this.coupon = data.price;
                        if (data.remark) {
                            this.show.message = true;
                        }

                        this.params = JSON.parse(JSON.stringify(data));
                        if (this.sendList.length !== 0 && this.acceptList.length !== 0) {
                            return;
                        }
                        let consigneeInfo = {
                            address: data.consigneeAddress,
                            cityId: data.consigneeCityId,
                            cityName: data.consigneeCityName,
                            districtId: data.consigneeDistrictId,
                            districtName: data.consigneeDistrictName,
                            name: data.consigneeName,
                            concatPhone: data.consigneePhone,
                            provinceId: data.consigneeProvinceId,
                            provinceName: data.consigneeProvinceName,
                            streetId: data.consigneeStreetId,
                            streetName: data.consigneeStreetName,
                            id: data.consigneeId || "",
                            packId: data.packId,
                            packName: data.packName,
                            payMeansId: data.payMeansId,
                            payMeansName: data.payMeansName,
                            productId: data.productId,
                            productName: data.productName,
                            goodsNumber: data.goodsNumber,
                            deliveryId: data.deliveryId,
                            deliveryName: data.deliveryName,
                            weight: data.weight,
                        };
                        this.$store.commit({
                            type: "confirmSelect",
                            t: "2",
                            list: [consigneeInfo]
                        });
                        let staOrderDetail = [];
                        data.list.forEach(value => {
                            Object.keys(value).forEach(key => {
                                if (key.indexOf("consignor") !== -1) {
                                    let k = key.substring("consignor".length, key.length);
                                    k = k.split("");
                                    k[0] = k[0].toLowerCase();
                                    k = k.join("");
                                    k = k === "phone" ? "concatPhone" : k;
                                    value[k] = value[key];
                                    delete value[key];
                                }
                            });
                            if (value.needWheelbarrow === 1) {
                                value.stc = true;
                            }
                            staOrderDetail.push(value);
                        });
                        this.$store.commit({
                            type: "confirmSelect",
                            t: "1",
                            list: staOrderDetail
                        });
                    }
                });
            },
            // 返回
            goBack() {
                this.$store.commit({
                    type: "confirmSelect",
                    t: "1",
                    list: []
                });
                this.$store.commit({
                    type: "confirmSelect",
                    t: "2",
                    list: []
                });
                this.$router.push("/order/detail?id=" + this.$route.params.id);
            },
            // 优惠券
            couponToggle() {
                if (!this.show.coupon) {
                    let params = {
                        params: {flag: 2}
                    };
                    this.$axios.post("coupon/getbyownerId", params).then(res => {
                        if (res.data.code === 200) {
                            let data = res.data.data;
                            data.forEach(val => {
                                let beginDate = new Date(val.beginDate);
                                let currentDate = new Date();
                                if (currentDate < beginDate) {
                                    val.isInvalid = true;
                                }
                            });
                            this.couponList = data;
                        }
                    });
                }
                this.show.coupon = !this.show.coupon;
            },
            selCoupon(item) {
                if (item.isInvalid) {
                    return;
                }
                this.params.couponId = item.id;
                this.coupon = item.price;
                this.couponToggle();
            },
            // 消息输入框
            messageToogle() {
                this.show.message = !this.show.message;
            },
            // 物流公司弹出框
            companyToggle() {
                if (this.sendList.length <= 0 || !this.acceptList) {
                    Dialog.alert({
                        message: "请选择提货地址与收货地址！"
                    }).then(() => {
                        return false;
                    });
                } else {
                    let params = {
                        params: {
                            flag: 2,
                            beginCityId: this.sendList[0].cityId,
                            beginProvinceId: this.sendList[0].provinceId,
                            endCityId: this.acceptList[0].cityId,
                            endProvinceId: this.acceptList[0].provinceId
                        }
                    };
                    this.$axios
                        .post("merchant/getLogisticsCompanyList", params)
                        .then(res => {
                            if (res.data.code === 200) {
                                let data = res.data.data;
                                this.companyList = data;
                                this.show.company = !this.show.company;
                            }
                        });
                }
            },
            // 拉包工弹出框
            workerToggle() {
                this.workerSearchKey = "";
                if (this.sendList.length <= 0) {
                    Dialog.alert({
                        message: "请先选择物流公司！"
                    }).then(() => {
                        return false;
                    });
                } else {
                    let params = {
                        params: {
                            name: "",
                            type: "3"
                        }
                    };
                    new Promise(resolve => {
                        this.$axios.post("merchantConcat/getListByType", params).then(res => {
                            if (res.data.code === 200) {
                                let data = res.data.data;
                                if (data.length > 0) {
                                    data[0].array.forEach(val => {
                                        if (!val.photo) {
                                            val.photo = require("../../assets/wuliu1.png");
                                        }
                                        val.show = true;
                                    });
                                    this.concatWorkerList = data[0].array;
                                }
                            }
                            resolve();
                        });
                    }).then(() => {
                        params = {
                            params: {
                                lat: this.sendList[0].lat,
                                lng: this.sendList[0].lng,
                                limit: 5,
                                radius: 10000
                            }
                        };
                        this.$axios.post("worker/circle/list", params).then(res => {
                            if (res.data.code === 200) {
                                let data = res.data.data;
                                data.forEach(val => {
                                    if (!val.photo) {
                                        val.photo = require("../../assets/wuliu1.png");
                                    }
                                    val.show = true;
                                });
                                this.workerList = data;
                                this.show.worker = !this.show.worker;
                            }
                        });
                    });
                }
            },
            // 搜索拉包工
            searchWorker() {
                this.workerList.forEach(val => {
                    if (
                        val.name.indexOf(this.workerSearchKey) !== -1 ||
                        val.phone.indexOf(this.workerSearchKey) !== -1
                    ) {
                        val.show = true;
                    } else {
                        val.show = false;
                    }
                });
                this.concatWorkerList.forEach(val => {
                    if (
                        val.name.indexOf(this.workerSearchKey) !== -1 ||
                        val.phone.indexOf(this.workerSearchKey) !== -1
                    ) {
                        val.show = true;
                    } else {
                        val.show = false;
                    }
                });
            },
            // 添加到通讯录
            addContact(val) {
                let params = {
                    params: {
                        is_black: 0,
                        name: val.name,
                        phone: val.phone,
                        photo: val.photo || "",
                        type: 3
                    }
                };
                this.$axios.post("merchantConcat/addContact", params).then(res => {
                    if (res.data.code === 200) {
                        Toast("添加成功！");
                    }
                });
            },
            // 快慢件弹出框
            transportwayToggle() {
                this.show.transport = !this.show.transport;
            },
            // 打包弹出框
            packToggle() {
                this.show.pack = !this.show.pack;
            },
            // 付款方式弹出
            payToggle() {
                this.show.pay = !this.show.pay;
            },
            // 运输方式弹出框
            deliveryToggle() {
                this.show.delivery = !this.show.delivery;
            },
            // 关闭
            closeCompany() {
                this.show.company = false;
            },
            closeWorker() {
                this.show.worker = false;
            },
            // 删除地址
            delSend(id) {
                this.$store.commit({
                    type: "selAddress",
                    t: "1",
                    id
                });
            },
            // 选择物流公司
            selCompany(index) {
                this.params.logisticsCompanyId = this.companyList[
                    index
                    ].logisticsCompanyId;
                this.params.logisticsCompanyName = this.companyList[
                    index
                    ].logisticsCompanyName;
                this.companyToggle();
            },
            // 选择拉包工
            selWorker(item) {
                this.workerRadio = item.userId;
                this.params.pullPackWorker = item.userId;
                this.params.pullPackWorkerName = item.name;
                this.workerToggle();
            },
            // 快慢件选择
            selTransport(item) {
                this.params.speedParts = item.dictValue;
                this.params.speedPartsName = item.dictName;
                this.transportwayToggle();
            },
            // 包装选择
            selPack(item) {
                this.params.packId = item.dictValue;
                this.params.packName = item.dictName;
                this.packToggle();
            },
            // 付款选择
            selPayMent(item) {
                this.params.payMeansId = item.dictValue;
                this.params.payMeansName = item.dictName;
                this.payToggle();
            },
            // 配送选择
            selDelivery(item) {
                this.params.deliveryId = item.dictValue;
                this.params.deliveryName = item.dictName;
                this.deliveryToggle();
            },
            // 重置
            cancelTransport() {
                this.params.speedPartsName = "特快件";
                this.params.speedParts = "1";
            },
            cancelPack() {
                this.params.packId = "";
                this.params.packName = "";
            },
            cancelPayMent() {
                this.params.payMeansName = "到付";
                this.params.payMeansId = "2";
            },
            cancelDelivery() {
                this.params.deliveryId = "3";
                this.params.deliveryName = "市场配送";
            },
            cancelTime() {
                this.params.planPickupTime = "";
                this.timeToggle();
            },
            cancelWorker() {
                this.workerRadio = "";
                this.params.pullPackWorker = "";
                this.params.pullPackWorkerName = "";
                this.workerToggle();
            },
            // 提交
            submit() {
                if (this.sendList.length <= 0) {
                    Dialog.alert({
                        title: "温馨提醒",
                        message: "请选择提货人地址！"
                    }).then(() => {
                        return false;
                    });
                    return false;
                }
                if (!this.acceptList) {
                    Dialog.alert({
                        title: "温馨提醒",
                        message: "请选择收货人地址！"
                    }).then(() => {
                        return false;
                    });
                    return false;
                }
                this.params.wechatMark = this.$wechatMark;
                //this.params.logisticsCompanyId = this.$logisticsCompanyId
                //this.params.logisticsCompanyName = this.$logisticsCompanyName
                this.params.orderType = 5
                this.params.consigneePhone = this.acceptList[0].concatPhone;
                this.params.consigneeName = this.acceptList[0].name;
                this.params.consigneeAddress = this.acceptList[0].address;
                this.params.consigneeProvinceId = this.acceptList[0].provinceId;
                this.params.consigneeProvinceName = this.acceptList[0].provinceName;
                this.params.consigneeCityId = this.acceptList[0].cityId;
                this.params.consigneeCityName = this.acceptList[0].cityName;
                this.params.consigneeDistrictId = this.acceptList[0].districtId;
                this.params.consigneeDistrictName = this.acceptList[0].districtName;
                this.params.consigneeStreetId = this.acceptList[0].streetId;
                this.params.consigneeStreetName = this.acceptList[0].streetName;
                this.params.packName=this.acceptList[0].packName;
                this.params.payMeansId=this.acceptList[0].payMeansId;
                this.params.payMeansName=this.acceptList[0].payMeansName;
                this.params.productId=this.acceptList[0].productId;
                this.params.productName=this.acceptList[0].productName;
                this.params.goodsNumber=this.acceptList[0].goodsNumber;
                this.params.deliveryName=this.acceptList[0].deliveryName;
                this.params.weight=this.acceptList[0].weight;
                this.params.consigneeId = this.acceptList[0].id;
                this.params.lat = this.sendList[0].lat || 0;
                this.params.lng = this.sendList[0].lng || 0;
                this.$set(this.params, "staOrderDetail", []);
                this.sendList.forEach(val => {
                    let obj = {
                        clothingCityId: val.clothingCityId,
                        consignorName: val.name,
                        consignorPhone: val.concatPhone,
                        consignorProvinceName: val.provinceName,
                        consignorProvinceId: val.provinceId,
                        consignorCityName: val.cityName,
                        consignorCityId: val.cityId,
                        consignorDistrictName: val.districtName,
                        consignorDistrictId: val.districtId,
                        consignorStreetName: val.streetName,
                        consignorStreetId: val.streetId,
                        consignorAddress: val.address,
                        deliveryWeight: val.deliveryWeight,
                        goodsNumber: this.data.goodsNumber || 1,
                        lat: val.lat || 0,
                        lng: val.lng || 0,
                        needWheelbarrow: 0,
                        planDeliveryDate: val.planDeliveryDate || "",
                        packId: val.packId || "",
                        packName: val.packName || "",
                        consignorId: val.id,
                        status: this.data.list[0].status,
                        statusName: this.data.list[0].statusName,
                        singleDate: this.data.list[0].singleDate,
                        pullPackWorker: this.data.list[0].pullPackWorker,
                        pullPackWorkerName: this.data.list[0].pullPackWorkerName
                    };
                    if (val.stc) {
                        obj.needWheelbarrow = 1;
                    }
                    this.params.staOrderDetail.push(obj);
                });
                let params = {
                    params: this.params
                };
                this.$axios.post("merchant/modify", params).then(res => {
                    if (res.data.code === 200) {
                        Dialog.alert({
                            title: "温馨提示",
                            message: "修改成功！"
                        }).then(() => {
                            this.$store.commit({
                                type: "confirmSelect",
                                t: "1",
                                list: []
                            });
                            this.$store.commit({
                                type: "confirmSelect",
                                t: "2",
                                list: []
                            });
                            this.$router.push("/order/detail?id=" + this.$route.params.id);
                            // window.location.reload()
                        });
                    } else {
                        window.location.reload();
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    #preorder {
        .back-icon {
            position: fixed;
            top: 0;
            left: 0.375rem;
            width: 1rem;
            line-height: 45px;
            z-index: 1000;
        }

        .address-list {
            margin-bottom: 0.25rem;

            .address-item {
                display: -webkit-box;
                -webkit-box-align: center;
                color: #999;

                .address-icon {
                    margin-right: 0.25rem;
                    width: 0.64rem;
                    height: 0.9rem;
                    display: block;
                    box-sizing: border-box;
                    padding: 4px 8px 12px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: 100%;

                    &.ji-icon {
                        background-image: url(../../assets/order2.png);
                    }

                    &.shou-icon {
                        background-image: url(../../assets/order1.png);
                    }
                }

                .address-book {
                    display: block;
                    width: 0.5rem;
                    height: 0.5rem;
                    background-image: url(../../assets/contact.png);
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-origin: content-box;
                    border-left: 1px solid #ddd;
                    padding-left: 0.25rem;
                }

                .address-book-btn {
                    font-size: 0.3rem;
                    line-height: 0.6rem;
                    display: block;
                    padding: 0 0.15rem;
                    border: 1px solid #0b92e6;
                    color: #0b92e6;
                    margin-left: 0.25rem;
                }

                .address-del {
                    display: block;
                    height: 0.6rem;
                    line-height: 0.6rem;
                    padding: 0 0.25rem;
                    border: 1px solid #0b92e6;
                    color: #0b92e6;
                }

                .info-name,
                .info-address {
                    color: #000;
                }
            }
        }

        .icon {
            display: block;
            width: 0.4rem;
            height: 0.4rem;
            margin-right: 0.25rem;
            background-size: 100%;
            background-repeat: no-repeat;

            &.info-shou {
                background-image: url(../../assets/icon_destination.png);
            }

            &.info-time {
                background-image: url(../../assets/icon_tihuo.png);
            }

            &.icon-company {
                background-image: url(../../assets/icon_company.png);
            }

            &.icon-worker {
                background-image: url(../../assets/icon_linkman.png);
            }

            &.icon-coupon {
                background-image: url(../../assets/icon_coupon.png);
                height: 0.5rem;
            }

            &.add-worker {
                background-image: url(../../assets/icon_addlinkman.png);
            }

            &.icon-transportway {
                background-image: url(../../assets/icon_type.png);
            }

            &.icon-pack {
                background-image: url(../../assets/icon_pack.png);
            }

            &.goods-weight {
                background-image: url(../../assets/icon_weight.png);
            }

            &.icon-payment {
                background-image: url(../../assets/icon_paymengt.png);
            }

            &.icon-delivery {
                background-image: url(../../assets/icon_delivery.png);
            }

            &.icon-microphone {
                background-image: url(../../assets/icon-microphone.png);
                width: 0.3rem;
                height: 0.45rem;
            }
        }

        .li-col {
            float: left;
            box-sizing: border-box;
            padding: 0.25rem 0.4rem;
            margin: 0.2rem 0;
            font-size: 0.35rem;
            position: relative;
            width: 100%;

            &.li-col-2 {
                width: 50%;
            }
        }

        .flex-layout {
            display: flex;
            align-items: center;
        }

        .order-info {
            width: 100%;
            background-color: #fff;
            border-bottom: 1px solid #eee;

            &::after {
                content: "";
                display: block;
                clear: both;
            }

            > .li-col-2 {
                &:nth-of-type(2n) {
                    border-left: 1px solid #eee;
                }

                > .info-name {
                    flex: 1;
                }

                > .coupon-price {
                    color: red;
                    margin-right: 0.25rem;
                }
            }
        }

        .goods-info {
            width: 100%;
            background-color: #fff;

            &::after {
                content: "";
                display: block;
                clear: both;
            }

            > .li-col-2 {
                border: 0;

                > .info-value {
                    flex: 1;
                }
            }
        }

        .btn {
            padding: 0.25rem;
        }

        .popup-title {
            position: relative;
            display: flex;
            align-items: center;
            padding: 0.25rem;
            font-size: 0.4rem;

            .van-button {
                margin-left: 0.25rem;
            }

            .van-icon {
                position: absolute;
                right: 0.25rem;
            }
        }

        .company-popup {
            .company-list {
                max-height: 6rem;
                overflow-y: scroll;

                .company-item {
                    .company-icon {
                        width: 1.25rem;
                        height: 1.25rem;
                        display: block;
                        background-image: url(../../assets/wuliu1.png);
                        background-size: 100%;
                        background-repeat: no-repeat;
                        border: 1px solid #ddd;
                        margin-right: 0.25rem;
                    }

                    .company-time {
                        float: right;
                    }
                }
            }
        }

        .worker-popup {
            .worker-list {
                .worker-item {
                    display: flex;
                    align-items: center;

                    .add2book {
                        display: block;
                        width: 45px;
                        font-size: 12px;
                        color: #b3b3b3;
                        line-height: 14px;
                    }

                    .worker-info {
                        width: 7rem;
                        display: flex;
                        align-items: center;

                        .worker-header {
                            width: 1.25rem;
                            height: 1.25rem;
                            display: block;
                            background-image: url(../../assets/wuliu1.png);
                            background-size: 100%;
                            background-repeat: no-repeat;
                            border: 1px solid #ddd;
                            margin-right: 0.25rem;
                        }
                    }
                }
            }
        }

        .coupon-popup {
            height: 10rem;
            overflow: hidden;

            .close-btn {
                display: inline-block;
                height: 0.5rem;
                width: 0.5rem;
                position: relative;
                transform: rotate(-45deg);
                margin-top: 0.25rem;
                margin-right: 0.25rem;

                &::before {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 100%;
                    border: 1px solid transparent;
                    border-bottom: 1px solid #999;
                    position: absolute;
                    top: -50%;
                }

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 100%;
                    border: 1px solid transparent;
                    border-right: 1px solid #999;
                    position: absolute;
                    left: -50%;
                }
            }
        }
    }

    .organ_name {
        float: right;
        padding: .1rem .3rem;
        font-weight: 300;
        border: 1px solid #ccc;
        border-radius: .5rem;
        margin-right: .3rem;
    }

    .organ_name_checked {
        color: red;
        border: 1px solid red;
        overflow: hidden;
    }
</style>


